export const PartnersConfig = [
  {
    name: 'account_api',
    logo: 'assets/images/partners/account.svg',
    title: 'Account API',
    description: 'Learn more about our Account API integration',
  },
  {
    name: 'tas',
    logo: 'assets/images/partners/talent.svg',
    title: 'Talent App Store',
    description: 'Learn more about our Talent App Store integration',
  },
  {
    name: 'bullhorn',
    logo: 'assets/images/partners/bullhorn.svg',
    title: 'Bullhorn',
    description: 'Learn more about our Bullhorn integration',
  },
  {
    name: 'jazzhr',
    logo: 'assets/images/partners/jazzhr.svg',
    title: 'JazzHr',
    description: 'Learn more about out JazzHR integration',
  },
  {
    name: 'teamtailor',
    logo: 'assets/images/partners/teamtailor.svg',
    title: 'Teamtailor',
    description: 'Learn more about our Teamtailor integration',
  },
  {
    name: 'job_adder',
    logo: 'assets/images/partners/job_adder.svg',
    title: 'JobAdder',
    description: 'Learn more about our JobAdder integration',
  },
  {
    name: 'lever',
    logo: 'assets/images/partners/lever.svg',
    title: 'Lever',
    description: 'Learn more about our Lever integration',
  },
  {
    name: 'ukg',
    logo: 'assets/images/partners/ukg.svg',
    title: 'UKG',
    description: 'Learn more about our workday integration',
  },
  {
    name: 'livehire',
    logo: 'assets/images/partners/livehire.svg',
    title: 'Livehire',
    description: 'Learn more about our livehire integration',
  },
  {
    name: 'onboarded',
    logo: 'assets/images/partners/onboarded.svg',
    title: 'Onboarded',
    description: 'Learn more about our onboarded integration',
  },
  {
    name: 'bambooHR',
    logo: 'assets/images/partners/bambooHR.svg',
    title: 'BambooHR',
    description: 'Learn more about our bambooHR integration',
  },
  {
    name: 'pageup',
    logo: 'assets/images/partners/pageUp.svg',
    title: 'PageUp',
    description: 'Learn more about our PageUp integration',
  },
  {
    name: 'smartrecruiters',
    logo: '/assets/images/smartrecruiters_logo.svg',
    title: 'SmartRecruiters',
    description: 'Learn more about our SmartRecruiters integration',
  },
];
